import React from 'react'
import { Link } from 'react-router-dom'

export const ActionBtn = (props) => {
  return (
  <>
    <div className='flex items-center space-x-4'>
                <div className='border border-neutral-200 rounded-lg inline-flex w-auto items-center'>
                 
{props?.work_status !=='open' && 
<Link className='border border-neutral-200 rounded-lg inline-flex  divide-x w-auto' to={`/individual/confirm-and-chat/${props?.jobId}`}>
<div className='py-1.5 px-2 cursor-pointer relative hover:text-[#0291d1] hover:rounded-l-lg hover:border-2 hover:border-[#0291d1] hover:bg-white'>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
</svg>
</div>
</Link>
}
<div onClick={props.deleteOnClick} className='py-1.5 px-2 cursor-pointer hover:text-[#a9252b] hover:border-2 hover:rounded-r-lg hover:border-[#f76266] hover:bg-[#FEEEEF]'>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
</svg></div>
</div>
                </div>
                </> )
}
